export const DOT_RADIUS = 4;
export const TOOLTIP_PADDING = 10;
